RivalIQ.apps.Favorites.module('views.forms', function (forms, App, Backbone, Marionette, $, _) {

    'use strict';

    forms.Composite = forms.Chart;
});
